import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { getCursorDataFunc } from "src/organization/pages/project/environment/metrics/http/helper";
import {
  CursorDataIndexFuncProp,
  CursorDataType
} from "src/organization/pages/project/environment/metrics/http/types";

let sharedWorker: Worker | undefined = undefined;

export function useCursorWorker<D>(func: CursorDataIndexFuncProp<D>) {
  const [cursorData, setCursorDataState] = useState<CursorDataType<D>>();
  const workerRef = useRef<Worker | null>(null);

  if (!sharedWorker) {
    sharedWorker = new Worker(new URL("./cursorWorker.ts", import.meta.url));
  }

  useEffect(() => {
    const worker = sharedWorker!;
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "update") {
        setCursorDataState(event.data.payload);
      }
    };

    worker.addEventListener("message", handleMessage);
    workerRef.current = worker;

    return () => {
      worker.removeEventListener("message", handleMessage);
    };
  }, []);

  const setCursorData = useCallback(
    (payload: CursorDataType<D> | null) =>
      workerRef.current?.postMessage({ type: "update", payload }),
    []
  );

  const handleCursorMove = useMemo(() => {
    return getCursorDataFunc({ ...func, setCursorData });
  }, [func, setCursorData]);

  return { cursorData, handleCursorMove };
}
